import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {Proposta} from "../aplicacao/models/proposta.model";
import {FiltroPaginacao, ListaPaginada} from "../bibliotecaPjus/models/comum.models";
import {IBibliotecaFormularioService, IBibliotecaTabelaService} from "../bibliotecaPjus/services/contrato.services";
import {BaseProviderService} from "./base-provider.service";
import {FiltroPropostaModel} from "../aplicacao/models/filtro-proposta.model";
import {AceiteParceiro} from "../aplicacao/models/nova-parceria/aceite-parceiro.model";

@Injectable({
  providedIn: 'root'
})
export class PropostaService extends BaseProviderService implements IBibliotecaTabelaService<Proposta, any, any>, IBibliotecaFormularioService<Proposta> {
  protected module = 'Proposta';

  constructor(protected http: HttpClient) {
    super(http);
  }

  criar(): Proposta {
    return new Proposta();
  }

  get(id: string): Observable<Proposta> {
    return this.http.get<Proposta>(this.getUrl(this.v1, this.module, [id]))
      .pipe(map(x => new Proposta(x)));
  }

  getCredor(id: string): Observable<AceiteParceiro> {
    return this.http.post<AceiteParceiro>(this.getUrl(this.v2, this.module, ['DadosCredor', id]), {})
      .pipe(map(x => new AceiteParceiro(x)));
  }

  list(pagina: number, qtd: number, status, objFiltro, subStatus = null): Observable<any> {
    const filtro = new FiltroPropostaModel(objFiltro);
    return this.http.get(this.getUrl(this.v1, this.module, ['Recuperar', 'Parceiro', 'Pagina', pagina, 'Quantidade', qtd + '?StatusProposta='+ status +
    (filtro.valorMin ? '&ValorMinimo=' + filtro.valorMin : '') +
    (filtro.valorMax ? '&ValorMaximo=' + filtro.valorMax : '') +
    (filtro.periodo ? '&DataInicio=' + filtro.periodo.start : '') +
    (filtro.periodo ? '&DataFim=' + filtro.periodo.end : '') +
    (filtro.documento ? '&DocumentoCedente=' + filtro.documento : '') +
    (subStatus ? '&' + subStatus : '')
    ])).pipe(map(d => new ListaPaginada<Proposta>(Proposta, d)));
  }

  filter(filter: FiltroPaginacao<any, any>): Observable<ListaPaginada<Proposta>> {
    return this.http.post<ListaPaginada<Proposta>>(this.getUrl(this.v1, this.module, ['filter']), filter)
      .pipe(map(d => new ListaPaginada<Proposta>(Proposta, d)));
  }

  atualizar(model: Proposta): Observable<Proposta> {
    return this.http.patch<Proposta>(this.getUrl(this.v1, this.module, [model.propostaId]), model).pipe(map(x => new Proposta(x)));
  }

  salvar(model: Proposta): Observable<Proposta> {
    delete model.propostaId;
    return this.http.post<Proposta>(this.getUrl(this.v1, this.module), model).pipe(map(x => new Proposta(x)));
  }

  aceitarOferta(model): Observable<Proposta> {
    return this.http.post<Proposta>(this.getUrl(this.v1, this.module, ['Aceite', 'Parceiro']), model).pipe(map(x => x));
  }

  deletar(id: number): Observable<Proposta> {
    return this.http.delete<Proposta>(this.getUrl(this.v1, this.module, [id]))
      .pipe(map(x => new Proposta(x)));
  }

  cancelarProposta(model): Observable<Proposta> {
    return this.http.post<Proposta>(this.getUrl(this.v1, this.module, ['Parceiro', 'ReprovarProposta']), model).pipe(map(x => x));
  }

  novoCalculo(model): Observable<Proposta> {
    return this.http.post<Proposta>(this.getUrl(this.v1, this.module, ['NovoCalculo', 'Proposta', model.propostaId]), model).pipe(map(x => x));
  }

  contraProposta(model: any): Observable<any> {
    return this.http.post(this.getUrl(this.v1, this.module, ['Parceiro', 'GerarContraProposta']), model).pipe(map(x => x));
  }

  contraPropostaV2(model: any): Observable<any> {
    return this.http.post(this.getUrl(this.v2, 'Parceria', ['Parceiro', 'GerarContraProposta']), model).pipe(map(x => x));
  }

  resumoOferta(id: string, idCotacao: string): Observable<any> {
    return this.http.get<any>(this.getUrl(this.v1, this.module, [
      'Parceiro',
      'ResumoOferta'
    ]) + `?PropostaId=${id}${idCotacao ? '&IdOferta=' + idCotacao : ''}`).pipe(map(x => x));
  }

}
